<template>
  <div>
    <PageAllow controller="SupplierMaterials" action="index" />
    <Breadcrumbs :items="items" />

    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5 mt-2">
          <span>
             {{ $t("Supplier.Fields.supplier_name") }}{{ $t("Global.colon") }}
          </span>
          <span class="red--text">
             {{ this.supplier ? this.supplier.supplier_name : '' }}
          </span>
        </v-row>
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="keyword"
                v-model="options.keyword"
                @text="supplierKeyword = $event"
                :label="$t('SupplierMaterials.Keyword')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-spacer />
              <v-btn
                v-if="settings && settings.account_supplier && supplier && supplier.type == 2 && $permission.permissionAllow('SupplierMaterials', 'syncAccountMaterials')"
                small
                color="warning"
                dark
                class="ms-1"
                @click="syncAccountMaterials()"
              >
                {{ $t("SupplierMaterials.syncAccountMaterials") }}
              </v-btn>
              <v-btn
                small
                dark
                color="action"
                @click.stop="selectMaterialsDialog = true"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
              </v-btn>
              <v-btn
                v-if="$permission.permissionAllow('SupplierMaterials', 'index')"
                small
                color="print"
                dark
                class="ms-1"
                @click="economyHistoryExport()"
              >
                {{ $t("SupplierMaterials.economyHistory") }}
              </v-btn>
              <!-- 发布价格，暂时隐掉 -->
              <v-tooltip
                top
                v-if="settings && settings.push_platform != '1012'"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    color="success"
                    class="ms-1"
                    style="display: none"
                    @click="releasePrice()"
                  >
                    {{ $t("SupplierMaterials.releasePrice") }}
                  </v-btn>
                </template>
                <span>{{ $t("SupplierMaterials.releasePriceHint") }}</span>
              </v-tooltip>
              <v-btn
                v-if="
                  $permission.permissionAllow(
                    'SupplierMaterials',
                    'addMaterialsImport'
                  )
                "
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="addImportDialog = true"
              >
                {{ $t("SupplierMaterials.batchAddMaterial") }}
              </v-btn>
              <v-btn
                v-if="
                  $permission.permissionAllow(
                    'SupplierMaterials',
                    'modifyMaterialPriceImport'
                  )
                "
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="modifyImportDialog = true"
              >
                {{ $t("SupplierMaterials.batchMaterial") }}
              </v-btn>
              <v-btn small color="success" @click="save()" class="ms-1">
                <v-icon x-small class="pe-1">fa-save</v-icon>
                {{ $t("CRUD.save") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-row dense class="mx-5">
          <v-col cols="12" sm="6" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherMaterialCategory v-model="materialCategorySelected" />
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" md="4"></v-col>
          <v-col cols="12" sm="6" md="4"></v-col>
        </v-row>

        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="materials"
            :loading="loading"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <!-- 历史报价 -->
            <template v-slot:item.history="{ item }">
              <v-btn
                small
                text
                class="primary--text pa-0"
                @click.stop="
                  currentDetail = item;
                  lineChartMaterialName = item.Description;
                  echartsDialog = true;
                "
              >
                <v-icon>fa-chart-area</v-icon>
              </v-btn>
            </template>
            <!-- 操作 -->
            <template v-slot:item.actions="{ item }">
              <v-btn
                small
                text
                class="danger--text pa-0"
                @click.stop="removeSupplyMaterials(item)"
              >
                <v-icon>fa-times</v-icon>
              </v-btn>
            </template>

            <template v-slot:body.prepend>
              <!-- 大 -->
              <tr class="d-none d-sm-table-row">
                <td></td>
                <td
                  :colspan="settings && settings.use_tax == 1 ? '6' : '4'"
                ></td>
                <td colspan="2" class="align-center">
                  <v-checkbox
                    v-if="useTax"
                    class="mt-2 mb-n2"
                    color="primary"
                    :indeterminate="
                      materials.find((e) => e.tax_flg != taxAll) ? true : false
                    "
                    v-model="taxAll"
                    :true-value="1"
                    :false-value="0"
                  >
                    <template v-slot:label>
                      <span class="caption ms-n2">
                        {{ $t("SupplierMaterials.taxAll") }}
                      </span>
                    </template>
                  </v-checkbox>
                </td>
                <td>
                  <v-checkbox
                    class="mt-2 mb-n2"
                    color="primary"
                    :indeterminate="
                      materials.find(
                        (e) => e.default_supplier_flg != settingAll
                      )
                        ? true
                        : false
                    "
                    v-model="settingAll"
                    :true-value="1"
                    :false-value="0"
                  >
                    <template v-slot:label>
                      <span class="caption ms-n2">
                        {{ $t("SupplierMaterials.settingAll") }}
                      </span>
                    </template>
                  </v-checkbox>
                </td>
                <td v-if="supplier && supplier.purchase_after_set_price">
                  <v-checkbox
                    v-if="supplier && supplier.purchase_after_set_price"
                    class="mt-2 mb-n2"
                    color="primary"
                    :indeterminate="
                      materials.find(
                        (e) => e.negotiate_price_flg != negotiatePriceSettingAll
                      )
                        ? true
                        : false
                    "
                    v-model="negotiatePriceSettingAll"
                    :true-value="1"
                    :false-value="0"
                  >
                    <template v-slot:label>
                      <span class="caption ms-n2">
                        {{ $t("SupplierMaterials.settingAll") }}
                      </span>
                    </template>
                  </v-checkbox>
                </td>
                <td></td>
                <td></td>
                <td>
                  <v-btn
                    small
                    text
                    class="danger--text pa-0"
                    @click.stop="removeAllSupplyMaterials()"
                  >
                    <v-icon>fa-times</v-icon>
                  </v-btn>
                </td>
              </tr>
              <!-- 小 -->
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header mt-1">
                    {{ $t("SupplierMaterials.Fields.tax_flg") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell mt-1">
                    <v-checkbox
                      class="mt-2 mb-n2"
                      color="primary"
                      :indeterminate="
                        materials.find((e) => e.tax_flg != taxAll)
                          ? true
                          : false
                      "
                      v-model="taxAll"
                      :label="$t('SupplierMaterials.taxAll')"
                    ></v-checkbox>
                  </div>
                </td>
              </tr>
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header mt-1">
                    {{
                      $t("SupplierMaterials.Fields.setting_default_material")
                    }}
                  </div>
                  <div class="v-data-table__mobile-row__cell mt-1">
                    <v-checkbox
                      class="mt-2 mb-n2"
                      color="primary"
                      :indeterminate="
                        materials.find(
                          (e) => e.default_supplier_flg != settingAll
                        )
                          ? true
                          : false
                      "
                      v-model="settingAll"
                      :true-value="1"
                      :false-value="0"
                    >
                      <template v-slot:label>
                        <span class="caption ms-n2">
                          {{ $t("SupplierMaterials.settingAll") }}
                        </span>
                      </template>
                    </v-checkbox>
                  </div>
                </td>
                <td
                  class="v-data-table__mobile-row"
                  v-if="supplier && supplier.purchase_after_set_price"
                >
                  <div class="v-data-table__mobile-row__header mt-1">
                    {{ $t("SupplierMaterials.Fields.negotiate_price_flg") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell mt-1">
                    <v-checkbox
                      class="mt-2 mb-n2"
                      color="primary"
                      :indeterminate="
                        materials.find(
                          (e) =>
                            e.negotiate_price_flg != negotiatePriceSettingAll
                        )
                          ? true
                          : false
                      "
                      v-model="negotiatePriceSettingAll"
                      :true-value="1"
                      :false-value="0"
                    >
                      <template v-slot:label>
                        <span class="caption ms-n2">
                          {{ $t("SupplierMaterials.settingAll") }}
                        </span>
                      </template>
                    </v-checkbox>
                  </div>
                </td>
              </tr>
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header mt-1">
                    {{ $t("SupplierMaterials.Fields.batchDelete") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell mt-1">
                    <v-btn
                      small
                      text
                      class="danger--text pa-0"
                      @click.stop="removeAllSupplyMaterials()"
                    >
                      <v-icon>fa-times</v-icon>
                    </v-btn>
                  </div>
                </td>
              </tr>
            </template>

            <template v-slot:item.Description="{ item, index }">
              <span :v-resize="!index ? $stickTableResizer() : null"> </span>
              <div class="d-inline-block ma-1">
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on"
                      class="d-block text-truncate"
                      style="max-width: 430px; cursor: pointer"
                      >
                       {{ $t("Material.materialNameWithCode", [item.material.material_code, item.material.material_name]) }}
                    </span>
                  </template>
                  {{ item.Description }}
                </v-tooltip>
                <span v-if="item.standard_name" class="caption secondary--text">
                  {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                  <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                    {{ item.standard_name.slice(0, 12) + "......" }}
                  </span>
                  <span v-else>
                    {{ item.standard_name }}
                  </span>
                </span>
              </div>
            </template>
            <template v-slot:item.material_category.name="{ item, index }">
              <span :v-resize="!index ? $stickTableResizer() : null">
                {{
                  item.new
                    ? item.material_category.name
                    : item.material.material_category.name
                }}
              </span>
            </template>

            <!-- 供货编码 -->
            <template v-slot:item.supply_code="{ item }">
              <div>
                <v-text-field
                  single-line
                  dense
                  hide-details
                  v-model="item.supply_code"
                  :value="item.supply_code"
                  style="max-width: 100px; margin-left: auto"
                  :disabled="supplier && supplier.purchase_after_set_price == 1"
                />
              </div>
            </template>
            <!-- 基准单位供货价 -->
            <template v-slot:item.default_price="{ item }">
              <v-row dense>
                <v-text-field
                  :ref="'default_price_input_' + item.id"
                  single-line
                  dense
                  hide-details
                  v-model="item.default_price"
                  type="number"
                  min="0"
                  :prefix="$t('Global.money')"
                  @blur="
                    item.default_price =
                      $numberFormatter.formatWithDotNoMoreThan(
                        item.default_price,
                        2
                      );
                    updateItemPrice('default', item);
                  "
                  style="
                    max-width: 100px;
                    margin-left: auto;
                    display: inline-block;
                  "
                  :disabled="!item.edit_default_price_flg"
                />
                <v-icon
                  dense
                  x-small
                  :color="item.edit_default_price_flg ? 'gray' : 'primary'"
                  style="display: inline-block"
                  class="mr-0"
                  @click="editPriceFlg('default', item)"
                  v-if="supplier && supplier.purchase_after_set_price != 1"
                >
                  fa-pencil-alt
                </v-icon>
              </v-row>
            </template>
            <!-- 单位 -->
            <template v-slot:item.unit="{ item }">
              <v-select
                single-line
                dense
                hide-details
                style="max-width: 60px; margin-left: auto"
                :items="item.standard.standard_details"
                item-text="unit"
                item-value="id"
                v-model="item.standard_detail_id"
                @change="updateItemPrice('unit', item)"
                :disabled="supplier && supplier.purchase_after_set_price == 1"
              />
            </template>
            <!-- 供货单价 -->
            <template v-slot:item.supply_price="{ item }">
              <v-row dense>
                <v-text-field
                  :ref="'supply_price_input_' + item.id"
                  single-line
                  dense
                  hide-details
                  v-model="item.supply_price"
                  type="number"
                  min="0"
                  :prefix="$t('Global.money')"
                  @blur="
                    item.supply_price =
                      $numberFormatter.formatWithDotNoMoreThan(
                        item.supply_price,
                        2
                      );
                    updateItemPrice('supply', item);
                  "
                  style="max-width: 100px; margin-left: auto"
                  :disabled="
                    !item.edit_supply_price_flg ||
                    (supplier &&
                      supplier.purchase_after_set_price == 1 &&
                      item.negotiate_price_flg == 1)
                  "
                />
                <v-icon
                  dense
                  x-small
                  :color="
                    item.edit_supply_price_flg ||
                    (supplier &&
                      supplier.purchase_after_set_price == 1 &&
                      item.negotiate_price_flg == 1)
                      ? 'gray'
                      : 'primary'
                  "
                  style="display: inline-block"
                  class="mr-0"
                  @click="editPriceFlg('supply', item)"
                >
                  fa-pencil-alt
                </v-icon>
              </v-row>
            </template>
            <!-- 是否含税 -->
            <template v-slot:item.tax_flg="{ item }">
              <div class="d-flex mt-n2 mb-n3">
                <v-checkbox
                  color="primary"
                  v-model="item.tax_flg"
                  :true-value="1"
                  :false-value="0"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{
                        $t(
                          item.tax_flg
                            ? "SupplierMaterials.Fields.tax_on"
                            : "SupplierMaterials.Fields.tax_off"
                        )
                      }}
                    </span>
                  </template>
                </v-checkbox>
              </div>
            </template>
            <!-- 税率 -->
            <template v-slot:item.tax_setting="{ item }">
              <div>
                <v-select
                  v-model="item.tax_rate"
                  :label="String(item.tax_rate)"
                  single-line
                  dense
                  hide-details
                  style="max-width: 60px; margin-left: auto"
                  :items="taxSetting"
                  item-text="tax_rate"
                  item-value="id"
                  suffix="%"
                />
              </div>
            </template>
            <template v-slot:item.default_supplier_flg="{ item }">
              <v-checkbox
                v-model="item.default_supplier_flg"
                :true-value="1"
                :false-value="0"
              ></v-checkbox>
            </template>
            <template v-slot:item.negotiate_price_flg="{ item }">
              <v-checkbox
                v-model="item.negotiate_price_flg"
                :true-value="1"
                :false-value="0"
              ></v-checkbox>
            </template>
            <!-- 备注 -->
            <template v-slot:item.memo="{ item }">
              <v-text-field
                single-line
                dense
                hide-details
                v-model="item.memo"
                style="max-width: 100px; margin-left: auto"
              >
                <template v-slot:append>
                  <v-icon
                    x-small
                    @click.stop="
                      detail_memo_item = item;
                      memoDialog = true;
                    "
                    class="pt-2 pb-1 primary--text"
                  >
                    fa-edit
                  </v-icon>
                </template>
              </v-text-field>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>

    <!-- 备注弹窗 -->
    <v-dialog v-model="memoDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          <span
            class="red--text d-inline-block text-truncate"
            style="max-width: 360px"
          >
            {{ detail_memo_item.Description }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="memoDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 pt-8">
          <v-textarea
            v-model="detail_memo_item.memo"
            outlined
            :label="$t('Order.DetailFields.memo')"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="memoDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <MaterialsSelectsDialog
      v-model="selectMaterialsDialog"
      :materialIds="materialIdsArr"
      :disabledChoosed="true"
      @confirm="
        selectDetails = $event;
        options.page = 1;
        getSupplierFromAPI();
      "
    />
    <ImportExcelAlert
      v-model="addImportDialog"
      :title="$t('SupplierMaterials.batchAddMaterial')"
      :objName="$t('SupplierMaterials.objName')"
      downloadTemplateUrl="download/template/supplier_materials_add_template.xlsx"
      @import="
        excelFile = $event;
        addImportExcel();
      "
      isTips
      :tipDetails="[$t('SupplierMaterials.importAlertOne')]"
    />
    <ImportExcelAlert
      v-model="modifyImportDialog"
      :title="$t('SupplierMaterials.batchMaterial')"
      :objName="$t('SupplierMaterials.objName')"
      downloadFromAPI
      @download="downloadImportTemplate()"
      @import="
        modifyExcelFile = $event;
        modifyImportExcel();
      "
      isTips
      :tipDetails="[
        $t('SupplierMaterials.importAlertTwo'),
        $t('SupplierMaterials.importAlertOne'),
      ]"
    />
    <DialogAlert
      v-model="errDialog"
      :message="errMsg"
      @close="
        err_flg = true;
        getSupplierFromAPI();
      "
    />
    <DialogEconomyHistoryEcharts
      v-model="echartsDialog"
      :currentDetail="currentDetail"
      :lineChartMaterialName="lineChartMaterialName"
      @close="echartsDialog = false"
    />
    <SyncErrorResult
      v-model="syncErrorDialog"
      :errorData="syncErrorData"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherMaterialCategory from "@/components/plugins/SearcherMaterialCategory";
import MaterialsSelectsDialog from "@/components/plugins/MaterialsSelectsDialog";
import SupplierMaterials from "@/api/supplier_materials";
import Suppliers from "@/api/suppliers";
import ImportExcelAlert from "@/components/plugins/ImportExcelAlert";
import DialogAlert from "@/components/plugins/DialogAlert";
import Quotations from "@/api/quotations";
import DialogEconomyHistoryEcharts from "@/components/plugins/DialogEconomyHistoryEcharts";
import SyncErrorResult from "./plugins/SyncErrorResult.vue";

const defaultOptions = {
  supplier_id: "",
  keyword: "",
  category_code: "",
};

export default {
  components: {
    Breadcrumbs,
    SearcherKeyword,
    PageAllow,
    SearcherMaterialCategory,
    MaterialsSelectsDialog,
    ImportExcelAlert,
    DialogAlert,
    DialogEconomyHistoryEcharts,
    SyncErrorResult,
  },

  computed: {
    taxSetting() {
      return this.settings && this.settings.tax_setting
        ? Object.values(this.settings.tax_setting)
        : "";
    },
    locale() {
      return this.$i18n.locale != "zhHans";
    },
    useTax() {
      return this.settings && this.settings.use_tax == 1 ? true : false;
    },
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.purchases"),
          disabled: false,
          href: "/supplier",
        },
        {
          text: i18n.t("Nav.supplier"),
          disabled: false,
          href: "/supplier",
        },
        {
          text: i18n.t("Nav.supplierMaterial"),
          disabled: true,
        },
      ];
    },
    headers() {
      var headers = [
        {
          text: i18n.t("SupplierMaterials.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "Description",
        },
        {
          text: i18n.t("SupplierMaterials.Fields.category_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "material_category.name",
        },
        {
          text: i18n.t("SupplierMaterials.Fields.supply_code"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "supply_code",
        },
        {
          text: i18n.t("SupplierMaterials.Fields.default_unit"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "standard.default_standard_detail.unit",
        },
        {
          text: i18n.t("SupplierMaterials.Fields.default_price"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          width: "150px",
          value: "default_price",
        },
        {
          text: i18n.t("SupplierMaterials.Fields.unit_order"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "unit",
        },
        {
          text: i18n.t("SupplierMaterials.Fields.supply_price"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          width: "150px",
          value: "supply_price",
        },
      ];
      if (this.settings && this.settings.use_tax == 1) {
        headers.push(
          {
            text: i18n.t("SupplierMaterials.Fields.tax_flg"),
            align: "start",
            class: "text-no-wrap",
            sortable: false,
            value: "tax_flg",
          },
          {
            text: i18n.t("SupplierMaterials.Fields.tax_setting"),
            align: "center",
            class: "text-no-wrap",
            sortable: false,
            value: "tax_setting",
          }
        );
      }
      headers.push({
        text: i18n.t("SupplierMaterials.Fields.setting_default_material"),
        align: "start",
        class: "text-no-wrap",
        sortable: false,
        value: "default_supplier_flg",
      });
      if (this.supplier && this.supplier.purchase_after_set_price) {
        headers.push({
          text: i18n.t("SupplierMaterials.Fields.negotiate_price_flg"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "negotiate_price_flg",
        });
      }
      headers.push(
        {
          text: i18n.t("SupplierMaterials.Fields.memo"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "memo",
        },
        {
          text: i18n.t("SupplierMaterials.Fields.history"),
          align: "center",
          sortable: false,
          value: "history",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        }
      );
      return headers;
    },

    ...mapState(["loading", "settings", "stickTableCols"]),
  },

  data: () => ({
    supplier: null,
    materials: [],
    options: {},
    supplierKeyword: "",
    selectMaterialsDialog: false,
    materialIdsArr: [],
    materialCategorySelected: null,
    taxAll: 1,
    settingAll: 0,
    negotiatePriceSettingAll: 0,
    selectDetails: [],
    deleteSupplyMaterialIDs: [],
    detail_memo_item: { memo: "" },
    memoDialog: false,
    addImportDialog: false,
    modifyImportDialog: false,
    excelFile: null,
    modifyExcelFile: null,
    err_flg: false,
    errDialog: false,
    errMsg: "",
    echartsDialog: false,
    lineChartMaterialName: "",
    currentDetail: null,
    syncErrorDialog: false,
    syncErrorData: [],
  }),

  mounted() {
    this.options = JSON.parse(JSON.stringify(defaultOptions));
    if (this.$route.params.id) {
      Suppliers.fetchOne(this.$route.params.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.supplier = response.data.supplier;
          }
        }.bind(this)
      );

      this.options.supplier_id = this.$route.params.id;
    }
  },

  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options, {
        keyword: this.supplierKeyword,
      });
    },
    getSupplierFromAPI() {
      var options = {};
      if (this.err_flg == true) {
        this.err_flg = false;
        options = Object.assign({}, this.options, {
          new_material_ids: [],
        });
      } else {
        options = Object.assign({}, this.options, {
          new_material_ids: this.selectDetails.map((d) => d.id),
        });
      }
      // 仅筛选少许必要字段
      let fieldFilter = [
          "id",
          "material_id",
          "enabled",
          "supply_code",
          "supply_price",
          "tax_flg",
          "tax_rate",
          "negotiate_price_flg",
          "memo",
          "Standard.id",
          "Standard.name",
          "standard_detail_id",
          "DefaultStandardDetail.id",
          "DefaultStandardDetail.unit",
          "Material.category_code",
          "MaterialCategory.name",
          "Material.default_supplier_id",
          "Material.material_code",
          "Material.material_name",
      ];
      options.fieldFilter = fieldFilter
      SupplierMaterials.fetchBySupplier(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materials = response.data.materials.map((detail) => {
              if (!this.materialIdsArr.includes(detail.material_id)) {
                this.materialIdsArr.push(detail.material_id);
              }

              //计算基准单位供货价
              let standard_detail = detail.standard.standard_details.find(
                (s) => s.id == detail.standard_detail_id
              );

              if (
                standard_detail &&
                Number(detail.supply_price) % Number(standard_detail.rate)
              ) {
                detail.default_price = Number(
                  this.$numberFormatter.formatTwoDot(
                    Number(detail.supply_price) / Number(standard_detail.rate)
                  )
                );
              } else {
                if (standard_detail) {
                  detail.default_price =
                    Number(detail.supply_price) / Number(standard_detail.rate);
                }
              }
              if (
                detail.material.default_supplier_id == this.$route.params.id
              ) {
                detail.default_supplier_flg = 1;
              }
              detail.edit_supply_price_flg = true;
              detail.edit_default_price_flg = false;
              detail.standard_name = detail.material.standard_name ? detail.material.standard_name : detail.standard.name


              detail.Description = i18n.t(
                this.settings
                  ? this.settings.material_name_display_type == 4
                    ? "Material.nameWithCodeAndStandard"
                    : this.settings.material_name_display_type == 3
                    ? "Material.materialNameWithCodeAndStandard"
                    : this.settings.material_name_display_type == 2
                    ? "Material.materialNameWithCode"
                    : "Material.materialName"
                  : "Material.materialName",
                [
                  detail.material.material_code,
                  detail.material.material_name,
                  detail.material.standard_name ? detail.material.standard_name : detail.standard.name,
                ]
              );
              return detail;
            });

            this.selectDetails = [];
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          } else if (response.data.error.code == "ERR844") {
            this.errDialog = true;
            this.errMsg = response.data.error.msg;
          }
        }.bind(this)
      );
    },

    editPriceFlg(field, material) {
      if (field == "default") {
        //供应单价input改为只读
        if (material.edit_supply_price_flg) {
          material.edit_supply_price_flg = false;
        }
        //基准单位单价input获取焦点
        if (!material.edit_default_price_flg) {
          material.edit_default_price_flg = true;
          this.$nextTick(() => {
            this.$refs["default_price_input_" + material.id].focus();
          });
        }
      } else if (field == "supply") {
        //基准单位单价input改为只读
        if (material.edit_default_price_flg) {
          material.edit_default_price_flg = false;
        }
        //供应单价input获取焦点
        if (!material.edit_supply_price_flg) {
          material.edit_supply_price_flg = true;
          this.$nextTick(() => {
            this.$refs["supply_price_input_" + material.id].focus();
          });
        }
      }
    },

    updateItemPrice(field, material) {
      if (
        field == "default" ||
        (field == "unit" && material.edit_default_price_flg)
      ) {
        let standard_detail = material.standard.standard_details.find(
          (s) => s.id == material.standard_detail_id
        );
        material.supply_price = Number(
          this.$numberFormatter.formatTwoDot(
            Number(material.default_price) * Number(standard_detail.rate)
          )
        );
      } else if (
        field == "supply" ||
        (field == "unit" && material.edit_supply_price_flg)
      ) {
        let standard_detail = material.standard.standard_details.find(
          (s) => s.id == material.standard_detail_id
        );
        if (Number(material.supply_price) % Number(standard_detail.rate)) {
          material.default_price = Number(
            this.$numberFormatter.formatTwoDot(
              Number(material.supply_price) / Number(standard_detail.rate)
            )
          );
        } else {
          material.default_price =
            Number(material.supply_price) / Number(standard_detail.rate);
        }
      }
    },

    removeSupplyMaterials(supply_material) {
      if (supply_material.new) {
        this.materials.splice(
          this.materials.findIndex(
            (material) => supply_material.new == material.new
          ),
          1
        );
      } else {
        //存移除的商品id
        this.materials.splice(
          this.materials.findIndex(
            (material) => supply_material.material_id == material.material_id
          ),
          1
        );
        this.deleteSupplyMaterialIDs.push(supply_material.material_id);
      }
    },
    removeAllSupplyMaterials() {
      //存移除的商品id
      this.deleteSupplyMaterialIDs = this.materials.map(function (material) {
        return material.material_id;
      });
      this.materials = [];
    },
    releasePrice() {
      this.$store.dispatch("fullscreenLoading");
      SupplierMaterials.releasePrice({
        supplier_id: this.$route.params.id,
      })
        .then(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(function () {
          this.$store.dispatch("fullscreenLoadingStop");
        });
    },
    save() {
      this.$store.dispatch("fullscreenLoading");
      var supplier_material_relations = this.materials.map(function (material) {
        return {
          standard_detail_id: material.standard_detail_id,
          supply_price: material.supply_price,
          supply_code: material.supply_code,
          material_id: material.new ? material.id : material.material_id,
          tax_flg: material.tax_flg,
          tax_rate: material.tax_rate,
          default_supplier_flg: material.default_supplier_flg,
          negotiate_price_flg: material.negotiate_price_flg,
          memo: material.memo,
        };
      });

      SupplierMaterials.batchSave({
        supplier_id: this.$route.params.id,
        supplier_material_relations: supplier_material_relations,
        delete_material_ids: this.deleteSupplyMaterialIDs,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getSupplierFromAPI();
              this.options.page = 1;
              this.deleteSupplyMaterialIDs = [];
            }else {
              if (response.data.error.code == "ERR668" && response.data.data) {
                this.syncErrorData = response.data.data
                this.syncErrorDialog = true;
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(function () {
          this.$store.dispatch("fullscreenLoadingStop");
        });
    },
    addImportExcel() {
      this.$store.dispatch("fullscreenLoading");
      SupplierMaterials.batchAddImports(this.$route.params.id, this.excelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              if (!response.data.err_data.length) {
                this.$snackbar.info(
                  i18n.t("Import.success", [
                    i18n.t("SupplierMaterials.objName"),
                  ])
                );
                this.addImportDialog = false;
                this.getSupplierFromAPI();
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    modifyImportExcel() {
      this.$store.dispatch("fullscreenLoading");
      SupplierMaterials.batchModifyImports(
        this.$route.params.id,
        this.modifyExcelFile
      )
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.info(
                i18n.t("Import.success", [i18n.t("SupplierMaterials.objName")])
              );
              this.modifyImportDialog = false;
              this.getSupplierFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    downloadImportTemplate() {
      SupplierMaterials.TemplateExport(this.$route.params.id);
    },
    economyHistoryExport() {
      Quotations.economyHistoryExport({supplier_id: this.$route.params.id})
    },
    syncAccountMaterials() {
      this.$store.dispatch("fullscreenLoading");
      SupplierMaterials.syncAccountMaterials(this.$route.params.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getSupplierFromAPI();
              this.$snackbar.success(i18n.t("SupplierMaterials.syncSuccessMgs"));
            }else {
              this.syncErrorData = response.data.data
              this.syncErrorDialog = true;
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
      ).catch(
        function () {
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
  },

  watch: {
    taxAll: {
      handler() {
        this.materials = this.materials.map(
          function (e) {
            e.tax_flg = this.taxAll ? 1 : 0;
            return e;
          }.bind(this)
        );
      },
    },

    settingAll: {
      handler() {
        this.materials = this.materials.map(
          function (e) {
            e.default_supplier_flg = this.settingAll ? 1 : 0;
            return e;
          }.bind(this)
        );
      },
    },
    negotiatePriceSettingAll: {
      handler() {
        this.materials = this.materials.map(
          function (e) {
            e.negotiate_price_flg = this.negotiatePriceSettingAll ? 1 : 0;
            return e;
          }.bind(this)
        );
      },
    },

    options: {
      deep: true,
      handler() {
        this.getSupplierFromAPI();
      },
    },

    materialCategorySelected: {
      handler() {
        this.options.category_code = this.materialCategorySelected
          ? this.materialCategorySelected.code
          : "";
      },
    },

    selectDetails: {
      handler() {
        // if (this.selectDetails.length) {
        //   this.selectDetails.forEach((selected) => {
        //     if (
        //       selected.choose &&
        //       this.materials.findIndex(
        //         (material) => material.id == selected.id
        //       ) == -1
        //     ) {
        //       //计算基准单位供货价
        //       if (
        //         Number(selected.in_price) %
        //         Number(selected.standard.default_standard_detail.rate)
        //       ) {
        //         selected.default_price = Number(
        //           this.$numberFormatter.formatTwoDot(
        //             Number(selected.in_price) /
        //               Number(selected.standard.default_standard_detail.rate)
        //           )
        //         );
        //       } else {
        //         selected.default_price =
        //           Number(selected.in_price) /
        //           Number(selected.standard.default_standard_detail.rate);
        //       }
        //       var newData = Object.assign({}, selected, {
        //         new: this.materials.length + 1,
        //         supplier_id: this.$route.params.id,
        //         supplier: this.supplier,
        //         tax_flg: 0,
        //         default_supplier_flg: 0,
        //         tax_setting: "",
        //         tax_rate: 0,
        //         standard_detail_id:
        //           selected.standard.default_standard_detail.id,
        //         supply_price: selected.in_price,
        //         edit_supply_price_flg: true,
        //         edit_default_price_flg: false,
        //       });
        //       this.materials.unshift(newData);
        //     }
        //   });
        // }
      },
    },
  },
};
</script>